import { createContext, useContext, useState, ReactNode } from 'react';

interface MagicFillContextType {
  // Loading global (quando usa MagicFillButton principal)
  isGlobalLoading: boolean;
  setGlobalLoading: (loading: boolean) => void;
  
  // Loading por campo (quando usa botão individual)
  loadingFields: Set<string>;
  setFieldLoading: (fieldKey: string, loading: boolean) => void;
  isFieldLoading: (fieldKey: string) => boolean;
}

const MagicFillContext = createContext<MagicFillContextType | undefined>(undefined);

export const MagicFillProvider = ({ children }: { children: ReactNode }) => {
  const [isGlobalLoading, setGlobalLoading] = useState(false);
  const [loadingFields, setLoadingFields] = useState<Set<string>>(new Set());

  const setFieldLoading = (fieldKey: string, loading: boolean) => {
    setLoadingFields(prev => {
      const newSet = new Set(prev);
      if (loading) {
        newSet.add(fieldKey);
      } else {
        newSet.delete(fieldKey);
      }
      return newSet;
    });
  };

  const isFieldLoading = (fieldKey: string) => {
    return loadingFields.has(fieldKey);
  };

  return (
    <MagicFillContext.Provider value={{ 
      isGlobalLoading, 
      setGlobalLoading, 
      loadingFields, 
      setFieldLoading, 
      isFieldLoading 
    }}>
      {children}
    </MagicFillContext.Provider>
  );
};

// eslint-disable-next-line react-refresh/only-export-components
export const useMagicFill = () => {
  const context = useContext(MagicFillContext);
  if (context === undefined) {
    return { 
      isGlobalLoading: false, 
      setGlobalLoading: () => {},
      loadingFields: new Set<string>(),
      setFieldLoading: () => {},
      isFieldLoading: () => false
    };
  }
  return context;
};
